import { LoginService } from 'src/app/login/login.service';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SYSCONF_LIMIT, SYSCONF_SIGLA } from '../../../../app.api';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { EstoqueService } from '../../estoque.service';
import { PreCadastroService } from 'src/app/pre-cadastro/pre-cadastro.service';
import { PessoaService } from '../../../pessoa/pessoa.service';
import { Movimentacao } from '../movimentacao';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-movimentacao-list',
	templateUrl: './movimentacaoList.component.html',
	styleUrls: ['./movimentacaoList.component.scss']
})

export class MovimentacaoListComponent implements OnInit{
	@ViewChild('Swal') public swal: SwalComponent;
	@ViewChild('SwalDelete') public swalDelete:SwalComponent; 
	@ViewChild('SwalFinish') public swalFinish:SwalComponent; 
	public movimentacao: Movimentacao[];
	movimentacao_id:number = null;
	public message:string = '';
	edit:boolean = false;
	detail:boolean = false;
	delete:boolean = false;
	create:boolean = false;
	locaisSelect = new Array();
	params = null;
	page = 1;
	totalPages:number = 1;
	recordsPerPage:number = SYSCONF_LIMIT;
	buscaForm: FormGroup;
	finishForm: FormGroup;
	formExportar: FormGroup;
	sigla = SYSCONF_SIGLA;
	constructor(private activatedRoute: ActivatedRoute,  private router: Router, private estoqueService: EstoqueService, public loginService: LoginService, private formBuilder: FormBuilder, private preCadastroService: PreCadastroService, private modalService: NgbModal){
		this.preCadastroService.getOptions('estoque/local')
        .subscribe( (success) => {
			this.locaisSelect = success.dados;
		},
		(error) => {
			// this.swal.text = error.error.message;
			// this.swal.type = "error";
			// this.swal.title = "Erro!";
			// this.swal.show();
		});

		this.buscaForm = this.formBuilder.group({
			id: this.formBuilder.control(''),
			tipo: this.formBuilder.control(''),
			origem_local_id: this.formBuilder.control(''),
			destino_local_id: this.formBuilder.control(''),
			status: this.formBuilder.control(''),
		});

	}
	changePage(event){
		let page = parseInt(event);
		let newParams:Object = new Object();
		this.activatedRoute.params.subscribe(
			param => {
				for(let i in param) {
					if(i != 'page') 
						newParams[i] = param[i];
				}
			})
		if(!page)
		return;
		this.router.navigate(['/'+SYSCONF_SIGLA+`/estoque/movimentacao/page/${page}`,newParams]);
	}
	ngOnInit(){ 
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(t.permissao.estoque_movimentacao.includes("CONSULTAR"))
			this.detail = true;
		if(t.permissao.estoque_movimentacao.includes("CRIAR"))
			this.create = true;
		if(t.permissao.estoque_movimentacao.includes("EDITAR"))
			this.edit = true;
		if(t.permissao.estoque_movimentacao.includes("EXCLUIR"))
			this.delete = true;
		this.activatedRoute.params.subscribe(params => {
			this.paramsChange(params);
		});
	}
	initFormExportar(){
		this.formExportar = this.formBuilder.group({
			campos: new FormArray([]),
		});
	}
	openExportModal(modal) {
		this.initFormExportar();
		this.modalService.open(modal,{size: 'lg', backdrop: 'static' });
	}
	askDelete(id:number){
		this.movimentacao_id = id;
		this.swalDelete.show();
	}

	confirmDelete(){
		this.estoqueService.del('movimento',this.movimentacao_id).subscribe( 
		(success) => {
			this.swal.text = "Movimentação deletada com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		});
	}

	askFinish(id:number){
		this.movimentacao_id = id;
		this.swalFinish.show();
	}

	confirmFinish(){
		this.finishForm = this.formBuilder.group({
			id: this.formBuilder.control(this.movimentacao_id),
			status: this.formBuilder.control(3),
		});
		this.estoqueService.edit('movimento', this.finishForm).subscribe( 
		(success) => {
			this.swal.text = "Movimentação concluída com sucesso!";
			this.swal.type = "success";
			this.swal.title = "Pronto!";
			this.swal.show();
		},
		(error) => {
			this.swal.text = error.error.message;
			this.swal.type = "error";
			this.swal.title = "Erro!";
			this.swal.show();
		});
	}

	paramsChange(params) {
		this.message = "";
		this.params = params;
		this.estoqueService.list('movimento',params)
		.subscribe(
			(movimentacao) => {
				this.movimentacao = movimentacao.dados;
				this.totalPages = movimentacao.paging.rows;
				this.page = params['page'];
			},
			(error) => {
				this.message = error.error.message;
			})
	}

	onSubmit(){
		this.router.navigate(['/'+SYSCONF_SIGLA+'/estoque/movimentacao/page/1',this.buscaForm.value]);
	}
	
	onCloseModal(){
		let params = new Array();
		params['page'] = 1;
		if(this.swal.type == "success"){
			this.estoqueService.list('movimento',params)
			.subscribe(
				(movimentacao) => {
					this.movimentacao = movimentacao.dados;
					this.totalPages = movimentacao.paging.rows;
					this.page = params['page'];
				},
				(error) => {
					this.message = error.error.message;
				})
		}
	}
}
